<template>
  <div class="wrapper">
    <v-banner :img="bannerImg" :text="bannerText"/>
    <div class="body">
      <p>
        众捷国际环境清洁（北京）有限公司成立于2012年，是一家集商业、写字楼、小区、酒店、公寓、政府机关、医院、工厂、大型餐饮的环境清洁、石材翻新、外墙清洗粉刷、空气检测净化等一体的综合性环境清洁服务公司。
      </p>
      <p>
        公司组织机构健全，管理制度完善，运行廉洁高效。公司下设保洁部、工程部、市场部、品质部、财务部等职能机构；公司大力实施人才战略，各部门管理人员和技术人员均受过不同程度的专业技术培训。公司注重企业文化，始终强调管理和服务的重要性，积极探索市场变幻，多方面、立体式进行自我完善与发展。
        公司现有员工500多人，管理人员30多人以及专业清洁设备、产品，全体员工在“为客户提供方便、快捷、高品质的清洁服务”目标的指导和共同努力下，先后承接了诸多知名楼盘和品牌的日常保洁、楼宇开荒、外墙清洗、石材翻新、外景灯具安装、绿化及养护工程等项目，得到各项目管理部的大力好评，今后公司会进一步适应现代的要求，与国际接轨，以专业创造品质，满足广大客户对清洁水平的更高要求。
      </p>
      <p>公司自成立以来，坚持勇于开拓、创新、信守合同、以服务质量争市场为立身之本，注重培养员工素质与专业技能，在竞争激烈的市场中，以优质高效的服务、专业的技术技能，以赢得客户的长久信赖与支持为目标。</p>
      <p>众捷将以更加至诚，更加专业，更高服务的标准回报客户，回报社会。</p>
      <!-- <p>&nbsp;</p>
      <p>公司服务理念：*****公司以顾客为上帝的经营理念，以真诚服务、尽善尽美为服务宗旨，永远为客户提供一流的服务。</p>
      <p>公司质量目标：*****质量就是命脉，信誉就是生命。</p>
      <p>公司服务承诺:*****创建一流团队，为客户提供专业化、个性化、素质化形象的超值服务。</p>
      <p>企业文化：*****阳光、自信、团结、责任</p> -->
      <h4>企业文化、经营理念</h4>
      <p>1、致力于为大众提供方便、快捷、优质的环境清洁服务供应商。</p>
      <p>2、以人为本的管理方式 细致规范的质量标准 认真敬业的工作态度 永争第一的进取精神。</p>
       <h4>质量目标</h4>
      <p>1、众捷深知清洁服务行业的生存之道，坚定不移奉行“以人为本，至诚至信”的原则，严格遵守质量认证体系标准，为客户提供方便、快捷、高品质的清洁服务，并且尤其注重对服务质量的监督和控制。公司追求服务效果是“把一切还给自然”，各种材质在有针对性处理后，将同时达到清洁、养护、杀菌、防腐、美观、同时延长设备设施的使用周期，达到为客户保值增值。</p>
      <p>2、客户满意率大于98%，客户投诉处置率100%</p>
    </div>
  </div>
  
</template>

<script>
import banner from "../banner/AboutBanner";
import bannerImg from "../../assets/image/About.jpg";
export default {
  components: {
    "v-banner": banner
  },
  props: {},
  data() {
    return {
      bannerImg: bannerImg,
      bannerText: "关于我们"
    };
  },
  watch: {},
  computed: {},
  methods: {},
  created() {},
  mounted() {}
};
</script>
<style lang="scss" scoped>
.wrapper {
  .body {
    padding: 40px 0 40px 0;
    h4{
      padding: 20px 0;
      font-size: 30px;
      color: #009f40;
      text-indent: 1em;
    }
    p {
      font-size: 14px;
      line-height: 30px;
      text-indent: 2em;
    }
  }
}
</style>